import { Moon, Sun, Music, Pause, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from 'react-i18next';

interface HeaderProps {
  isDark: boolean;
  toggleTheme: () => void;
  isPlaying: boolean;
  toggleMusic: () => void;
}

const Header = ({ isDark, toggleTheme, isPlaying, toggleMusic }: HeaderProps) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ru' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <header className="fixed top-0 right-0 z-50 p-6 flex gap-3">
      {/* Language Toggle */}
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleLanguage}
        className="rounded-full bg-card/80 backdrop-blur-sm shadow-card hover:bg-primary hover:text-primary-foreground transition-all duration-300"
        aria-label="Toggle language"
      >
        <Globe className="h-5 w-5" />
      </Button>

      {/* Theme Toggle */}
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleTheme}
        className="rounded-full bg-card/80 backdrop-blur-sm shadow-card hover:bg-primary hover:text-primary-foreground transition-all duration-300"
        aria-label="Toggle theme"
      >
        {isDark ? (
          <Sun className="h-5 w-5" />
        ) : (
          <Moon className="h-5 w-5" />
        )}
      </Button>

      {/* Music Toggle */}
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleMusic}
        className="rounded-full bg-card/80 backdrop-blur-sm shadow-card hover:bg-primary hover:text-primary-foreground transition-all duration-300"
        aria-label={isPlaying ? "Pause music" : "Play music"}
      >
        {isPlaying ? (
          <Pause className="h-5 w-5" />
        ) : (
          <Music className="h-5 w-5" />
        )}
      </Button>
    </header>
  );
};

export default Header;